import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/features/auth/authentication/services/auth.service';
import { AuthReturnUrlService } from '../services/auth-return-url.service';

/**
 * Keeps an already-authenticated user off the login page, sending them to the
 * deep link that bounced them here if there is one, and to the orders list
 * otherwise.
 */
@Injectable({
  providedIn: 'root'
})
export class LoggedInAuthGuard implements CanActivate {
  /** Orders list — see CLAUDE.md: the orders table is the quotations component. */
  private static readonly FALLBACK_URL = '/quotations';

  constructor(
    private authService: AuthService,
    private router: Router,
    private returnUrl: AuthReturnUrlService
  ) {}

  canActivate(): boolean | UrlTree {
    if (!this.authService.getAuthStatus()) {
      return true;
    }

    // parseUrl, not navigate: a UrlTree lets the router cancel and redirect in
    // one pass, and it preserves the query string of the original deep link.
    return this.router.parseUrl(
      this.returnUrl.consume() ?? LoggedInAuthGuard.FALLBACK_URL
    );
  }
}
